
class ArticleSteps {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement(){
    return this.element;
  }

  getSteps() {
    let element = this.getElement();
    return element.querySelectorAll('.js-steps');
  }

  getNav(){ 
    let element = this.getElement();
    return element.querySelectorAll('.js-navStep');
  }

  setNavClick() {
    let navEl = this.getNav();
    for (let nav of navEl) {
      nav.addEventListener('click', () => {
        nav.closest('.js-navStepContainer').querySelector('.active').classList.remove('active');
        nav.classList.add('active');
      })
    }
  }


  detectStep() {
    let stepEl = this.getSteps();
    let navEl = this.getNav();

    let options = {
      threshold: .7
    }

    const observer = new IntersectionObserver((entries, options) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
        } 
        else {
          let handleEl = entry.target.dataset.handle;
          for (let nav of navEl) {
            let navHandle = nav.dataset.handle;
            navHandle === handleEl ? nav.classList.add('active') : null;
            if(navHandle === handleEl) {
              nav.closest('.js-navStepContainer').querySelector('.active').classList.remove('active');
              nav.classList.add('active');
            }
          }
        }
      });
    }, options);

    for(let step of stepEl) {
      observer.observe(step);
    }
  }

  setEventHandlers() {
    this.setNavClick();
  }

  init() {
    this.setEventHandlers();
  }
}


const ArticleStepsInit = {
  init() {
    const $el = document.querySelector(".js-article");
    if ($el) {
        new ArticleSteps($el);
    }
  },
};


export default ArticleStepsInit;

